import { useTheme } from '@emotion/react';
import React from 'react';

import { ArrowDownIcon } from '~src/icons/arrow-down-icon';
import { fontStyles } from '~src/theme/fontStyles';
import { ButtonProps, plainButtonStyle } from '~src/ui/plain-button';

interface CountrySelectDropdownProps extends ButtonProps {
  open: boolean;
}

export const CountrySelectDropdown: React.FC<CountrySelectDropdownProps> = ({
  children,
  open,
  ...props
}) => {
  const theme = useTheme();

  return (
    <button
      aria-expanded={open}
      css={[plainButtonStyle, styles.wrapper]}
      className="focus-visible-outline"
      type="button"
      {...props}
    >
      <span css={styles.label}>{children}</span>
      <ArrowDownIcon color={theme.darkGrey} />
    </button>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    height: '20px',
  },
  label: {
    ...fontStyles.px14_20,
  },
};
